import request from '@/utils/request'

// 查询产品维护列表
export function listBjlfproduct(query) {
  return request({
    url: '/system/bjlfproduct/list',
    method: 'get',
    params: query
  })
}

// 查询产品维护详细
export function getBjlfproduct(id) {
  return request({
    url: '/system/bjlfproduct/' + id,
    method: 'get'
  })
}

// 新增产品维护
export function addBjlfproduct(data) {
  return request({
    url: '/system/bjlfproduct',
    method: 'post',
    data: data
  })
}

// 修改产品维护
export function updateBjlfproduct(data) {
  return request({
    url: '/system/bjlfproduct',
    method: 'put',
    data: data
  })
}

// 删除产品维护
export function delBjlfproduct(id) {
  return request({
    url: '/system/bjlfproduct/' + id,
    method: 'delete'
  })
}
